import getAssetTitleForBrowsers from './getAssetTitleForBrowsers';

export default getAssetTitleForBrowsers;
